export default {
    "fr": {
        "Subscribe to our newsletter": "Inscrivez-vous à notre newsletter",
        "Subscribe": "S'inscrire",
        "Placeholder": "Email",
        "Success": "Inscription réussie",
        "Agree": "J'accepte de recevoir des emails marketings"
    },
    "en": {
        "Subscribe to our newsletter": "Subscribe to our newsletter",
        "Subscribe": "Subscribe",
        "Agree": "I agree to receive marketing emails",
        "Placeholder": "Email",
        "Success": "Registration successful"
    }
}
